import { render, staticRenderFns } from "./DetailRequest.vue?vue&type=template&id=f32b30e0&scoped=true&"
import script from "./DetailRequest.vue?vue&type=script&lang=js&"
export * from "./DetailRequest.vue?vue&type=script&lang=js&"
import style0 from "./DetailRequest.vue?vue&type=style&index=0&id=f32b30e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32b30e0",
  null
  
)

export default component.exports